
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Minibusonrentinpune() {



  const cardData =
  {
    keyword: ' Mini Bus On Rent in Pune',
    heading: 'Vaishnavi Travels: Mini Bus On Rent in Pune',
    headingDescription: 'Vaishnavi Travels provides affordable and reliable Mini Bus on Rent in Pune, ideal for weddings, school trips, corporate outings, family tours, and outstation journeys. Our mini buses are well-maintained with spacious seating, powerful air-conditioning, and ample luggage space, ensuring a smooth and comfortable travel experience for medium-sized groups. With professional drivers, timely pickups, and flexible booking options, we make group travel hassle-free and convenient. Whether it’s a religious yatra, weekend picnic, or business trip, Vaishnavi Travels guarantees safe, reliable, and comfortable mini bus rental services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, is Pune’s most iconic fort palace and the former seat of the Peshwas. The majestic gates, sprawling courtyards, and ancient ruins narrate tales of Maratha valor. Though partially destroyed by a fire in 1828, it still captivates thousands of visitors daily. The evening light-and-sound show recreates the story of Bajirao and Mastani. Tourists love exploring its fountains, gardens, and hidden pathways. Shaniwar Wada is Pune’s cultural and historic crown jewel."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a monument of national importance linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s personal belongings, letters, and photographs. The palace’s Italian arches and landscaped gardens add serene charm. Visitors enjoy peaceful strolls here while reflecting on history. Aga Khan Palace is Pune’s proud symbol of sacrifice and heritage."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is a legendary hilltop fortress famous for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. Trekkers climb to the fort for panoramic views of the Sahyadris. Visitors explore bastions, gates, and memorials that echo Maratha bravery. In monsoon, mist, rain, and waterfalls make the trek magical. Local villagers serve authentic pithla-bhakri, adding rustic flavor. Sinhagad Fort is Pune’s adventurous and historic getaway."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. Established more than 125 years ago, the temple houses a grand idol adorned with gold and jewels. During Ganesh Chaturthi, it becomes the epicenter of grand celebrations attracting lakhs of devotees. Known for its charitable initiatives, it serves as a hub of devotion and culture. The spiritual aura here is uplifting for all. Dagdusheth Ganpati Temple is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved in the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. Its massive stone pillars, sanctum, and Nandi mandapa showcase ancient Indian craftsmanship. Despite being located in the city center, it offers peace and meditation. Evening chants enhance its spiritual aura. History and architecture lovers admire its timeless simplicity. Pataleshwar Cave Temple is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure trove housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include ornaments, musical instruments, sculptures, and antiques of everyday life. A highlight is the recreated Mastani Mahal, evoking Maratha history and romance. Students and tourists find the museum educational and inspiring. It preserves centuries of Indian traditions under one roof. Raja Dinkar Kelkar Museum is Pune’s proud showcase of art and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. At the top stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum add to its cultural depth. Pilgrims climb 103 steps to reach the top, combining devotion with scenic beauty. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of spirituality and wellness. Spread across serene gardens, it attracts seekers from all over the world. The ashram offers meditation sessions, yoga practices, and personal growth workshops. Its Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a retreat for rejuvenation and healing. Osho Ashram is Pune’s international destination of peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, also called the Okayama Friendship Garden, is Pune’s largest landscaped park inspired by Japan’s Korakuen Garden. It features flowing streams, stone bridges, and manicured lawns. Families enjoy photography, picnics, and peaceful evening walks here. Seasonal flowers and lush greenery add vibrant charm. It also symbolizes Indo-Japanese cultural friendship. Pu La Deshpande Garden is Pune’s green paradise of calm and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is Pune’s favorite weekend escape. It provides water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates a mesmerizing spectacle. Families gather here to enjoy roasted corn and hot tea by the banks. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla Dam is Pune’s natural retreat for relaxation and leisure."
  }
],


         "services": [
    {
      "name": "Pune Mini Bus Hire",
      "description": "Reliable and convenient mini bus hire service in Pune, offering 20 to 25 seater buses perfect for group travel. Whether for city tours, family outings, corporate events, or special occasions, these mini buses provide spacious seating and comfortable interiors, ensuring a smooth journey for all passengers."
    },
    {
      "name": "20–25 Seater Mini Bus Rental",
      "description": "Spacious 20 to 25 seater mini buses available for rent in Pune, suitable for medium-sized groups. Ideal for school trips, family vacations, corporate outings, and tour operators seeking comfortable and safe transportation. Equipped with ample legroom, sturdy seats, and modern amenities to keep travelers comfortable on short or long journeys."
    },
    {
      "name": "AC Mini Bus Pune",
      "description": "Experience travel in cool comfort with our air-conditioned mini buses in Pune. Perfect for hot summer days and long-distance trips, these AC buses feature climate control systems, clean interiors, and smooth rides, making them the preferred choice for corporate travel, sightseeing tours, and family excursions."
    },
    {
      "name": "Non AC Mini Bus on Rent",
      "description": "Affordable and budget-friendly non-AC mini bus rentals available in Pune. These vehicles provide a reliable and economical option for group travel within the city or nearby outstation destinations. Ideal for travelers seeking cost-effective transport without compromising on safety or space."
    },
    {
      "name": "Corporate Mini Bus Service",
      "description": "Professional mini bus rental services tailored for corporate clients in Pune. Perfect for employee shuttles, business events, client transportation, and team outings. Our corporate mini buses come with clean interiors, courteous drivers, and flexible scheduling to meet your organizational needs."
    },
    {
      "name": "School Trip Mini Bus Hire",
      "description": "Safe and comfortable mini bus hire service dedicated to school trips in Pune. Vehicles are equipped with seat belts, safety locks, and experienced drivers trained in child safety protocols. Perfect for educational excursions, sports meets, and field trips with reliable timings and supervision."
    },
    {
      "name": "Family Mini Bus Rental",
      "description": "Family-friendly mini bus rental service offering spacious seating and convenience for group vacations, weddings, or special family occasions in Pune. Drivers are courteous and experienced, ensuring a pleasant travel experience with ample storage space for luggage."
    },
    {
      "name": "Wedding Mini Bus Pune",
      "description": "Elegant mini bus rentals tailored for weddings and related events in Pune. These buses provide comfortable and stylish transportation for guests, with options for decorations and customizable routes. Ideal for shuttling guests between venues, hotels, and ceremonial locations seamlessly."
    },
    {
      "name": "Outstation Mini Bus on Rent",
      "description": "Outstation mini bus rentals from Pune available for long-distance trips to destinations like Lonavala, Mahabaleshwar, Goa, and more. Vehicles come equipped with reliable drivers, ample luggage space, and comfortable seating to ensure a smooth journey across varied terrains and road conditions."
    },
    {
      "name": "Budget Mini Bus Hire Pune",
      "description": "Cost-effective mini bus rental options in Pune for budget-conscious travelers and groups. These buses offer essential amenities and dependable service, balancing affordability with safety and convenience for city tours, short trips, and group travel."
    },
    {
      "name": "Mini Bus with Driver Pune",
      "description": "Hire mini buses in Pune inclusive of professional drivers who are familiar with local routes and traffic patterns. Drivers maintain high standards of safety, punctuality, and customer service, ensuring stress-free travel for all passengers."
    },
    {
      "name": "Online Mini Bus Booking",
      "description": "Easy and secure online booking system for mini bus rentals in Pune. Instant confirmation, multiple payment options, and real-time vehicle tracking make planning your group travel hassle-free and transparent."
    },
    {
      "name": "Tourist Mini Bus Service Pune",
      "description": "Specialized tourist mini bus services offering guided tours around Pune and nearby attractions. Ideal for sightseeing groups, tourists, and travel agencies, these buses come equipped with panoramic windows, audio guides, and comfortable seating for an immersive travel experience."
    }
  ],
  "tableData": [
    ["Pune Mini Bus Hire", "20–25 Seater Mini Bus Rental"],
    ["AC Mini Bus Pune", "Non AC Mini Bus on Rent"],
    ["Corporate Mini Bus Service", "School Trip Mini Bus Hire"],
    ["Family Mini Bus Rental", "Wedding Mini Bus Pune"],
    ["Outstation Mini Bus on Rent", "Budget Mini Bus Hire Pune"],
    ["Mini Bus with Driver Pune", "Online Mini Bus Booking"],
    ["Tourist Mini Bus Service Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Mini Bus On Rent in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers reliable and comfortable mini bus rental services in Pune, perfect for group travel, corporate events, school trips, and tours."
  },
  {
    "WhyChooseheading": "Variety of Seating Capacities",
    "WhyChoosedescription": "Choose mini buses with seating options ranging from 20 to 32 seats, tailored to your group size and travel requirements."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our mini buses are regularly serviced and cleaned to ensure a safe and hygienic journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our courteous drivers are trained for safety and punctuality, familiar with Pune and surrounding areas."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy all-inclusive rates with no hidden fees—covering fuel, tolls, taxes, and driver allowance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Available for hourly, daily, or multi-day rentals with customizable routes and timings."
  },
  {
    "WhyChooseheading": "Perfect for Various Occasions",
    "WhyChoosedescription": "Ideal for corporate outings, weddings, school trips, sightseeing tours, and more."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Seamless Booking",
    "WhyChoosedescription": "Our team is available round-the-clock to assist you with bookings, itinerary planning, and travel support."
  }
]
















  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer mini bus rentals in Pune?',
      answer: 'Yes, Vaishnavi Travels provides mini bus rentals in Pune, ideal for group travel, corporate events, school trips, and sightseeing tours.',
    },
    {
      question: 'What is the seating capacity of the mini buses available for rent?',
      answer: 'Our mini buses typically seat between 20 to 30 passengers comfortably, making them perfect for medium-sized groups.',
    },
    {
      question: 'What amenities are included in the mini bus rentals?',
      answer: 'Our mini buses come equipped with air-conditioning, comfortable seating, ample luggage space, and a professional driver to ensure a pleasant journey.',
    },
    {
      question: 'Are the mini buses well-maintained and safe?',
      answer: 'Absolutely! All vehicles are regularly serviced and maintained to meet safety standards, ensuring a safe and comfortable ride.',
    },
    {
      question: 'What are the rental charges for mini buses in Pune?',
      answer: 'Rental charges typically start from ₹7,000 per day, varying based on the duration, distance, and specific requirements of the trip.',
    },
    {
      question: 'Can I hire a mini bus for outstation trips from Pune?',
      answer: 'Yes, Vaishnavi Travels offers mini bus rentals for both local and outstation trips, including destinations like Lonavala, Mahabaleshwar, Goa, and more.',
    },
    {
      question: 'Is advance booking required for mini bus rentals?',
      answer: 'It is recommended to book at least 3-4 days in advance, especially during peak travel seasons and weekends to ensure availability.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Sanjay Kulkarni",
    position: "Event Organizer",
    feedback:
      "We rented a mini bus from Vaishnavi Travels for a corporate event in Pune. The bus was spacious, clean, and the driver was very professional. Highly satisfied!",
    rating: 5,
  },
  {
    name: "Ms. Meera Joshi",
    position: "School Administrator",
    feedback:
      "Vaishnavi Travels provided us with an excellent mini bus for our school trip. The vehicle was comfortable, and the service was prompt and reliable.",
    rating: 5,
    style: "style-2",
  }
];












































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "BusReservation",
  "name": "Mini Bus On Rent in Pune",
  "description": "Affordable 20-25 seater mini bus rental services in Pune for corporate events, school trips, family outings, weddings, and outstation travel. AC and Non-AC options available with driver.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "areaServed": "Pune",
    "url": "https://vaishnavitravel.com/mini-bus-rental-pune"
  },
  "serviceType": "Mini Bus Rental",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/mini-bus-rental-pune"
  }
};




  return (
    <div>

<Helmet>
  <title>Mini Bus On Rent in Pune | 20-25 Seater Mini Bus Rental</title>
  <meta
    name="description"
    content="Affordable 20-25 seater mini bus rental services in Pune for corporate events, school trips, family outings, weddings, and outstation travel. AC and Non-AC options available with driver."
  />
  <meta
    name="keywords"
    content="Pune Mini Bus Hire, 20-25 Seater Mini Bus Rental, AC Mini Bus Pune, Non AC Mini Bus on Rent, Corporate Mini Bus Service, School Trip Mini Bus Hire, Family Mini Bus Rental, Wedding Mini Bus Pune, Outstation Mini Bus on Rent, Budget Mini Bus Hire Pune, Mini Bus with Driver Pune, Online Mini Bus Booking, Tourist Mini Bus Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(serviceSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/60.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpune;